module.exports = __webpack_public_path__ + "static/media/majorF7.07ea95f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF7.wav
// module id = eWUq
// module chunks = 0